import React from 'react';
import { IFulfillmentInfoProps } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/FulfillmentInfo/FulfillmentInfo';
import { HeadingAndValues } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/HeadingAndValues';

export type IPickupInfoProps = IFulfillmentInfoProps;

export function PickupInfo({ date }: IPickupInfoProps): JSX.Element {
  return <HeadingAndValues heading="Pickup date" values={[date]} />;
}
